import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import { MyProfileAvatar } from '@/components/my-profile-avatar.tsx';
import { PersonalInformationCard } from '@/features/user-profile/components/personal-information-card.tsx';
import { AccountInformationCard } from '@/features/user-profile/components/account-information-card.tsx';
import { ActiveSessionsCard } from '@/features/user-profile/components/active-session-card.tsx';
import { AccountApiKeys } from '@/features/user-profile/components/account-api-keys.tsx';

const MyProfile = () => {
  return (
    <div className="w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Profile Settings</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <div className="flex flex-col gap-6">
            <div className="max-w-4xl space-y-8">
              <PersonalInformationCard />
              <AccountInformationCard />
              <AccountApiKeys />
              <ActiveSessionsCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
